import React, {  useRef } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import {  EMPTY_OBJECT } from '../../constants/globalConstants'
require('./FileUpload.scss')

function DocumentUpload(props) {
    const { name, accept, onChange, id, idProof, required, disabled,label,formError } = props
    const hiddenFileInput = useRef(null)

    const handleClick = () => {
        hiddenFileInput.current.click()

      }
    // const renderErrors = () => {
    //     const { errors, name } = props
    //     if (!errors || !errors[name]) return false


    //     return errors[name].map((e, i) => <div key={i} className="error" style={{ color: 'red' }}>{e}</div>)
    // }
        return (
            <div className="w-full">
                <div className=" position-relative">
                <label className="form-label">{label} <span className='text-danger'> {required ? '*':''}</span> </label>
                    <div className='input-group'>
                    <button type='button' onClick={handleClick} className='btn btn-primary'>Upload</button>
                        <input type="text" onClick={handleClick} className='form-control'  value={id == 'front' ? idProof?.front?.name ? idProof?.front?.name : 'Select file' : idProof?.uploadFile?.name ? idProof?.uploadFile?.name : 'Select file'}  readOnly />
                    </div>
                    <div className='relative'>
                    <input                             
                        aria-describedby="emailHelp"
                        type="file"
                        ref={hiddenFileInput}
                        hidden
                        accept={accept}
                        onChange={onChange}
                        name={name}
                        className='form-control'
                        id={id}
                        disabled={disabled}
                        required={required}
                    />
                    <span 
                        className={'absolute right-2 touch-none top-1'}
                        htmlFor={id}
                    ></span>
                    </div>
					<span className="form-text text-danger h-40">{formError == 'home' && required && Object.keys(idProof).length==0 ? 'Please upload the required document' : ''}</span>

                </div>
                <small>
						(File type : (jpeg, jpg, png), File Size : (10MB))
					</small>

                {/* {renderErrors()} */}

            </div>
        )
    }

DocumentUpload.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    errors: PropTypes.objectOf(
        PropTypes.arrayOf(PropTypes.string)
    ),
    id: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    accept: PropTypes.string,
    idProof:PropTypes.object,
    label: PropTypes.string,
    formError:PropTypes.string,
}
DocumentUpload.defaulProps = {
	name: undefined,
    onChange: noop,
    errors: EMPTY_OBJECT,
    id: undefined,
    required: false,
    disabled: false,
    accept: undefined,
    idProof:EMPTY_OBJECT,
    label:undefined,
    formError:undefined
}

const mapStateToProps = () => {
    return {} // Return props object
}

export default connect(mapStateToProps)(DocumentUpload)
